import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertSnakeCaseToTitle',
})
export class ConvertSnakeCaseToTitlePipe implements PipeTransform {
  transform(value: string): string {
    if (value) {
      value = value.replace(/_/g, '-');
      return value
        .split('-')
        .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    } else {
      return '';
    }
  }
}
